import React, { Component } from 'react';
import moment from 'moment';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { timezones } from '../../../../utils/constants';

import {
  InputField,
  CheckboxField,
  DateField,
  SelectField,
  required,
  parseDecimal,
  number,
  cron,
  timezone,
  minValue,
  dateGtnToday,
  dateGtnDate,
  isValidSlug,
  TooltipLabel,
} from '../../../form';

class FeedDetails extends Component {
  endDateValidation = (endDate, allValues) => {
    if (allValues.details && !allValues.details.recurring && endDate) {
      const validGtnDate = dateGtnDate(endDate, allValues.details.start_date);
      const validTdyDate = dateGtnToday(endDate);
      if (validTdyDate) return validTdyDate;
      if (validGtnDate) return validGtnDate;
    }

    return undefined;
  };

  fetchStatus() {
    const { initialValues } = this.props;

    if (initialValues && initialValues.details.status === 'removed') {
      return [{ label: 'Removed', value: 'removed' }];
    }

    return [
      { label: 'Active', value: 'active' },
      { label: 'Paused', value: 'paused' },
    ];
  }

  render() {
    const { isRecurring, accountOptions, initialValues } = this.props;
    const timezoneOptions = timezones.map(tz => ({ label: tz, value: tz }));
    const startDatePassed = initialValues && moment().isAfter(initialValues.details.start_date) ? true : false;
    const isRemoved = initialValues && (initialValues.details.status === 'removed' ? true : false);

    return (
      <div>
        <Field
          type="text"
          name="details[account_id]"
          label="Account"
          validate={[required]}
          disabled={initialValues !== undefined}
          component={SelectField}
          options={accountOptions}
          normalize={field => (field ? field.value : field)}
        />
        <Field type="text" name="details[name]" label="Name" validate={[required, isValidSlug]} component={InputField} />
        <Field type="text" name="details[budget]" label="Budget ($)" validate={[required, number, minValue(1)]} component={InputField} />
        <Field name="details[recurring]" label="Monthly Recurring" type="checkbox" singleLine component={CheckboxField} />
        <Field
          type="text"
          name="details[status]"
          label="Status"
          validate={[required]}
          disabled={isRemoved}
          component={SelectField}
          options={this.fetchStatus()}
          normalize={field => (field ? field.value : field)}
        />
        <Field
          type="text"
          name="details[start_date]"
          label="Start Date"
          disabled={startDatePassed}
          autoComplete={false}
          validate={startDatePassed ? [] : [required, dateGtnToday]}
          component={DateField}
        />
        <Field
          type="text"
          name="details[end_date]"
          label="End Date"
          autoComplete={false}
          validate={isRecurring ? [] : [required, this.endDateValidation]}
          disabled={isRecurring}
          component={DateField}
        />
        <Field name="details[is_open]" label="Open Budget" type="checkbox" singleLine component={CheckboxField} />
        <Row>
          <Col xs={8}>
            <Field
              type="text"
              name="cron"
              label={
                <TooltipLabel tooltipId="cron" labelText="Feed Refresh Schedule">
                  A schedule for determining when to refresh a feed in a cron format
                </TooltipLabel>
              }
              validate={[required, cron]}
              component={InputField}
              helpText={
                <div>
                  For generating a cron schedule see{' '}
                  <a href="https://crontab.guru/" rel="noopener noreferrer" target="_blank">
                    Crontab Guru
                  </a>
                </div>
              }
            />
          </Col>
          <Col xs={4}>
            <Field
              type="text"
              name="cron_timezone"
              label="Timezone"
              validate={[required, timezone]}
              component={SelectField}
              options={timezoneOptions}
              defaultValue="EST"
              normalize={field => (field ? field.value : field)}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default FeedDetails;
